import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import { City } from '../types/profile';

interface CityStoreState {
  query: string;
  results: City[];
  cities: City[];
  loading: boolean;
  hasSettledCitiesLoad: boolean;
  selectedCity: City | null;
  setQuery: (query: string) => void;
  searchCities: (query: string) => Promise<City[]>;
  fetchCities: () => Promise<City[]>;
  setSelectedCity: (city: City | null) => void;
}

export const useCityStore = create<CityStoreState>((set, get) => ({
  query: '',
  results: [],
  loading: false,
  hasSettledCitiesLoad: false,
  selectedCity: null,
  cities: [],
  setQuery: query => set({ query }),
  setSelectedCity: city => set({ selectedCity: city }),
  searchCities: async (query: string) => {
    set({ loading: true, query });
    const { data, error } = await supabase.rpc('search_cities_unaccent', {
      q: query,
      city_code: '10',
    });
    if (error) {
      console.error('Error fetching cities:', error);
      set({ results: [], loading: false });
      return [];
    }
    set({ results: (data as City[]) || [], loading: false });
    return data || [];
  },

  fetchCities: async () => {
    if (get().loading) return get().cities;
    set({ loading: true });
    try {
      const { data, error } = await supabase
        .from('cities')
        .select('id, name')
        .order('name', { ascending: true });

      if (error) {
        throw error;
      }

      if (data) {
        set({ cities: data as City[], loading: false });
        return data;
      }

      console.log('data==', data);

      return get().cities;
    } catch (error) {
      console.error('Error fetching cities:', error);
      return get().cities;
    } finally {
      set({ loading: false, hasSettledCitiesLoad: true });
    }
  },
}));
